<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="fn-header">
                    การจัดการแพคเกจมบัตรเติมเกม
                </div>


                <div class="row search-section">
                    <div class="col-sm-2 col-search">

                        <button type="button" class="btn bg-teal waves-effect btn-search" @click="add()">
                            <i class="material-icons">add_box</i>
                            <span>สร้างแพคเกจบัตรเติมเกม</span>
                        </button>

                    </div>
                    <div class="col-sm-5 col-search"></div>
                    <div class="col-sm-2 col-search">
                        <input type="text" class="search-textbox" v-model="key"
                            placeholder="กรุณากรอกชื่อแพคเกจบัตรเติมเกม เพื่อค้นหา" style="width:100%;margin-top:5px">
                    </div>

                    <div class="col-sm-2 col-search">
                        <button type="button" class="btn bg-blue-grey  waves-effect btn-search" :disabled="searching"
                            @click="search(1)">
                            <i class="material-icons">search</i>
                            <span>ค้นหา</span>
                        </button>
                    </div>
                    <div class="col-sm-1 col-search">
                        <button type="button" class="btn bg-grey waves-effect btn-search" :disabled="searching"
                            @click="reset()">
                            <i class="material-icons">refresh</i>
                            <span>Reset</span>
                        </button>
                    </div>

                </div>
                <div class="row ">
                    <div class="col-sm-12 " style="text-align: right;">
                        <img src="static/images/excel.png" class="excel-icon" alt="download excel"
                            style="margin-right: 15px;cursor: pointer;" @click="download()" />
                    </div>
                </div>
                <div class="body table-responsive" style="width:100%">
                    <div class="preloader pl-size-xl" v-if="searching == true || loading == true">
                        <div class="spinner-layer pl-orange">
                            <div class="circle-clipper left">
                                <div class="circle"></div>
                            </div>
                            <div class="circle-clipper right">
                                <div class="circle"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else>


                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th class="fn-th" style="width: 80px;">No.</th>
                                    
                                    <th class="fn-th">บัตรเติมเกม</th>
                                    <!-- <th class="fn-th">ชื่อแพ็คเกจ</th> -->
                                    <th class="fn-th">ราคา</th>
                                    <th class="fn-th">กำไร</th>
                                    <th class="fn-th">สถานะ</th>
                                    <th class="fn-th">แก้ไข</th>
                                    <th class="fn-th">ลบ</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in items" :key="'p-' + item.id"
                                    :class="{ 'fn-tr-light': index % 2, 'fn-tr-dark': !(index % 2) }">
                                    <td v-html="((page-1) * perpage) + index + 1"></td>
                                   

                                    <td style="text-align: center;">
                                        <span>{{ item.name }}</span>
                                    </td>

                                    <!-- <td style="text-align: center;">
                                        <span>{{ item.package_name }}</span>
                                    </td> -->
                                    <td style="text-align: center;">
                                        <span>{{ item.price }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.profit }}</span>
                                    </td>
                                    <td style="text-align: center;">
                                        <span>{{ item.active == 1 ? 'Active' : 'Inactive' }}</span>
                                    </td>
                                   

                                    <td>
                                        <span @click="edit(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon">mode_edit</i>
                                            </a>
                                        </span>
                                    </td>
                                    <td>
                                        <span @click="del(item.id)">
                                            <a href="#">
                                                <i class="material-icons fn-icon" style="color:red;">cancel</i>
                                            </a>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <Paginate v-model=page :page-count=pages :page-range="5" :click-handler="search" :prev-text="'Prev'"
                        :next-text="'Next'" :container-class="'fn-pagination'" />


                </div>
            </div>
        </div>
        <div class="modal fade" id="card-package-modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="padding:10px">

                        <span style="color: #466aa7;font-size: 15px;font-weight: bold;">สร้างแพ็คเกจบัตรเติมเกม</span>
                    </div>
                </div>
                <div class="modal-body" style="background:white;min-height: 0;">

                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ค่ายมือถือ</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <select v-model="card_id" class="form-control  show-tick fn-required" @change="getPackage(card_id)">
                                <option :value="0">เลือกค่ายมือถือ</option>
                                 <option v-for="(value,index) in cards" :key="'company-key-' + index" :value="value.id" v-html="value.name"></option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2  col-label">
                            <span>ชื่อแพ็คเกจ</span>
                        </div>
                        <div class="col-sm-10">
                           
                            <input type="text" class="form-control fn-required" v-model="package.package_name" placeholder="กรุณากรอกชื่อแพ็คเกจ">
                        </div>
                    </div> -->
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>ราคา</span>
                        </div>
                        <div class="col-sm-6">
                            <select v-model="package.price" class="form-control  show-tick fn-required" >
                                
                                 <option v-for="(value,index) in prices" :key="'company-key-' + index" :value="value" v-html="value"></option>
                            </select>
                        </div>
                    </div>
                     <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>กำไร</span>
                        </div>
                        <div class="col-sm-6">
                            <input type="number" class="form-control fn-required" v-model="package.profit" placeholder="กรุณากรอกกำไร">
                        </div>
                    </div>
                    <div class="row" style="margin-top: 15px;">
                        <div class="col-sm-2 col-label">
                            <span>สถานะ</span>
                        </div>
                        <div class="col-sm-6">
                            <select class="form-control  show-tick fn-required" v-model="package.active">
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                            </select>
                        </div>
                    </div>

                </div>
                <div class="modal-footer" style="background:white">
                    <button type="button" class="btn btn-primary waves-effect" style="width: 150px;"
                        @click="handleSave()">บันทึก</button>
                    <button type="button" class="btn btn-default waves-effect" style="width: 150px;"
                        data-dismiss="modal">ปิด</button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import CardService from '../../service/CardService'
import CardPackageService from '../../service/CardPackageService'
import WepayService from '../../service/WepayService'
import helper from '../../classes/helper'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment'
import alertBox from '../../classes/alertBox'
import Paginate from 'vuejs-paginate'
import { compare } from 'semver';

export default {
    name: "CardPackageManage",
    components: {
        DatePicker,
        Paginate
    },
    data() {
        return {
            user: JSON.parse(localStorage.getItem('user')),
            page: 1,
            perpage: 50,
            total: 0,
            pages: 0,
            items: [],
            card_id: 0,
            package: {
                id: 0,
                company_id: 0,
                package_name: "",
                price: 0,
                profit: 0,
                active: "1",
                created_by:0
            },
            cards: [],
            prices: [],
            company_id: 0,
            key: "",
            searching: false,
            loading: true,
        }
    },
    async created() {
        
        await this.getCards()
        await this.getData()
            await this.search(1)
        this.loading = false
    },
    mounted() {

    },
    methods: {
         async getCards() {
            let response = await CardService.get()
          
            if(response.status){
                this.cards = response.result
            }
        },
         async getData() {
            let response = await WepayService.get('cashcard')
         
            if(response.status){
                this.companies = response.result
            }
        },
        async getPackage(card_id){
            let card = this.cards.find(x => x.id == card_id)
            let company = this.companies.find(x => x.company_id == card.company_id)
            if(company){
               
                 this.prices = company.denomination.map(x => x.price)
            }
           
        },
        async search(p = 0) {
            this.loading = true
            if (p > 0) {
                this.page = p
            }
            let response = await CardPackageService.search(this.key, this.page, this.perpage)
           
            if (response.status) {
                let { page, perpage, total, pages, data } = response.result
                this.page = Number(page)
                this.perpage = Number(perpage)
                this.total = Number(total)
                this.pages = Number(pages)
                this.items = data

            }
            this.loading = false
        },
        reset(p = 1) {
            this.key = ""
            this.company_id = 0
            this.search(p)
        },
        add() {
            this.package = {
                id: 0,
                card_id: 0,
                package_name: "",
                price: 0,
                profit: 0,
                active: "1",
                created_by: this.user.id
            }
            $('#card-package-modal').modal('show')
        },
        edit(id) {
            
            let item = this.items.find(x => x.id == id)
            this.package = { ...item, updated_by: this.user.id }
            this.card_id = item.card_id
           
            $('#card-package-modal').modal('show')
        },
        async handleSave() {
            if (!this.validate()) {
                return false
            }

            if (this.package.id == 0) {
                await this.create()
            }
            else {
                await this.update()
            }

            $('#card-package-modal').modal('hide')
        },
        validate() {
            // if (!this.package.package_name) {
            //     alertBox.error("กรุณากรอกชื่อแพ็กเกจ")
            //     return false
            // }
            

            return true
        },
        async create() {
            try {
            
                this.package.card_id = this.card_id
              
                let response = await CardPackageService.create(this.package)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async update() {
            try {
                this.package.card_id = this.card_id
                let response = await CardPackageService.update(this.package)
               
                if (response.status) {
                    alertBox.success('save success')
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
            catch (error) {
                alertBox.error("Error, " + error)
            }
        },
        async del(id) {
            let result = await alertBox.confirm('คุณแน่ใจที่จะลบ?')
            if (result) {
                let data = {
                    id: id,
                    updated_by: this.user.id
                }
                let response = await CardPackageService.delete(data)

                if (response.status) {
                    this.reset(this.page)
                }
                else {
                    alertBox.error("Error, " + response.error)
                }
            }
        }

    },
    filters: {
        comma(value) {
            return helper.WithComma(value)
        },
        date(value) {
            if (!value) return ""

            return moment(value).format('DD/MM/YYYY HH:mm')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Manage/CardPackage.vue